import {Card, Col, Row, Skeleton, Tabs} from 'antd';
import type {TabsProps} from 'antd';
import {useEffect, useState} from 'react';
import {useBreadcrumbContext} from '../../../../../domain/utility/AppContextProvider/BreadcrumbContextProvider';
import IntlMessages from '../../../../../domain/utility/IntlMessages';
import {useIntl} from 'react-intl';
import EditProductAttributeHeader from './edit-product-attribute-header';
import {useParams} from 'react-router-dom';
import ProductAttributesPredefinedValues from './product-attributes-predefined-values';
import {ProductAttributeDetailsDto} from '../../../../../shared/services/product-attribute/dto/product-attribute-details-dto';
import {productAttributesService} from '../../../../../shared/services/product-attribute';

interface IEditProductAttributesProps {}

const EditProductAttributes = (props: IEditProductAttributesProps) => {
  const {setBreadcrumb}: any = useBreadcrumbContext();

  const {id} = useParams();

  const {messages} = useIntl();

  const [
    isProductAttributesDetailsLoading,
    setIsProductAttributesDetailsLoading,
  ] = useState(false);

  const [productAttributesDetails, setProductAttributesDetails] =
    useState<ProductAttributeDetailsDto>();

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          setIsProductAttributesDetailsLoading(true);
          let productAttributesDetails =
            await productAttributesService.getProductAttributeById(id);
          setProductAttributesDetails(productAttributesDetails);
        } catch (error) {
          console.error(error);
        } finally {
          setIsProductAttributesDetailsLoading(false);
        }
      })();
    }
  }, [id]);

  useEffect(() => {
    setBreadcrumb([
      {
        text: <IntlMessages id='Catalog.sideBarName' />,
        url: '/catalog/products',
      },
      {
        text: <IntlMessages id='catalog.attributes' />,
        url: '/catalog/catalog.attributes/product-attributes',
      },
      {
        text: <IntlMessages id='catalog.productAttributes' />,
        url: '/catalog/catalog.attributes/product-attributes',
      },
      {
        text: <IntlMessages id='common.edit' />,
        url: `/catalog/catalog.attributes/product-attributes/edit-product-attribute/${id}`,
      },
    ]);
  }, [id]);

  const itemsTab: TabsProps['items'] = [
    {
      key: 'predefinedValues',
      label: `${messages[
        'productAttributes.productAttributesPredefinedValues'
      ].toString()}`,
      children: (
        <ProductAttributesPredefinedValues
          productAttributesDetails={productAttributesDetails}
        />
      ),
    },
  ];

  return (
    <Card>
      <Skeleton active loading={isProductAttributesDetailsLoading}>
        <Row gutter={[0, 48]}>
          <Col span={24}>
            <EditProductAttributeHeader
              productAttributesDetails={productAttributesDetails}
            />
          </Col>

          <Col span={24}>
            <Tabs defaultActiveKey='attributeInfo' items={itemsTab} />
          </Col>
        </Row>
      </Skeleton>
    </Card>
  );
};

export default EditProductAttributes;
